import axios from "@/plugins/axios";
import { storeErrorHandler } from "@/utils/utils";

export default {
  namespaced: true,

  state: {
    loading: {
      fetch: false,
      send: false,
    },
  },

  getters: {
    loading: (state) => state.loading,
  },

  mutations: {
    SET_LOADING(state, { key, value }) {
      state.loading[key] = value;
    },
  },

  actions: {
    async fetch({ commit }, params) {
      try {
        commit("SET_LOADING", { key: "fetch", value: true });

        const { data } = await axios.get("reports", { params });

        return data;
      } catch (err) {
        return storeErrorHandler(err.response);
      } finally {
        commit("SET_LOADING", { key: "fetch", value: false });
      }
    },

    async send({ commit }, payload) {
      try {
        commit("SET_LOADING", { key: "send", value: true });

        const { data } = await axios.post("reports", payload);

        return data;
      } catch (err) {
        return storeErrorHandler(err.response);
      } finally {
        commit("SET_LOADING", { key: "send", value: false });
      }
    },
  },
};
